import { request } from '@/utils/request.js';

const login = (data, callback, errCallback, finCallback) => {
  request({
    url: '/authenticate/login',
    method: 'POST',
    data: data,
    noToken: true,
    success: callback,
    fail: errCallback,
    complete: finCallback,
  });
};

const register = (data, callback, errCallback, finCallback) => {
  request({
    url: '/authenticate/register',
    method: 'POST',
    data: data,
    noToken: true,
    success: callback,
    fail: errCallback,
    complete: finCallback,
  });
};

const changePwd = (data, callback, errCallback, finCallback) => {
  request({
    url: '/authenticate/change_pwd',
    method: 'POST',
    data: data,
    noToken: true,
    success: callback,
    fail: errCallback,
    complete: finCallback,
  });
};

const authRefreshToken = (refreshToken, callback, errCallback, finCallback) => {
  request({
    url: '/authenticate/refresh',
    method: 'POST',
    token: refreshToken,
    success: callback,
    fail: errCallback,
    complete: finCallback,
  });
};

const sendSmsCode = (data, callback, errCallback, finCallback) => {
  request({
    url: '/authenticate/sms_code',
    method: 'POST',
    data: data,
    success: callback,
    fail: errCallback,
    complete: finCallback,
  });
};

const getUserInfo = (callback, errCallback, finCallback) => {
  request({
    url: '/user/user_info',
    method: 'GET',
    success: callback,
    fail: errCallback,
    complete: finCallback,
  });
};

const submitOrganization = (data, callback, errCallback, finCallback) => {
  request({
    url: '/user/organization',
    method: 'POST',
    data: data,
    success: callback,
    fail: errCallback,
    complete: finCallback,
  });
};

const submitUserInfo = (data, callback, errCallback, finCallback) => {
  request({
    url: '/user/user_info',
    method: 'POST',
    data: data,
    success: callback,
    fail: errCallback,
    complete: finCallback,
  });
};

const checkIdentifierCode = (data, callback, errCallback, finCallback) => {
  request({
    url: '/user/check_identifier_code',
    method: 'POST',
    data: data,
    success: callback,
    fail: errCallback,
    complete: finCallback,
  });
};

const addRole = (role, callback, errCallback, finCallback) => {
  request({
    url: '/user/add_role',
    method: 'POST',
    data: {
      role: role,
    },
    success: callback,
    fail: errCallback,
    complete: finCallback,
  });
};

const getWxShareConfig = (url, callback, errCallback, finCallback) => {
  request({
    url: '/user/wx_share_config',
    method: 'POST',
    data: {
      url: url,
    },
    success: callback,
    fail: errCallback,
    complete: finCallback,
  });
};

export {
  login,
  register,
  changePwd,
  getUserInfo,
  authRefreshToken,
  sendSmsCode,
  submitOrganization,
  submitUserInfo,
  checkIdentifierCode,
  addRole,
  getWxShareConfig,
};



// WEBPACK FOOTER //
// ./src/servers/user.js